export const getAdminErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { response?: { data?: Record<string, unknown> } })?.response?.data
  const message = data?.message ?? data?.errorMessage ?? data?.error
  if (typeof message === 'string' && message.trim() !== '') {
    return message
  }
  return fallback
}
